import { Box, TextareaAutosize } from "@mui/material";
import type { Theme } from "@mui/material/styles";
import React from "react";

interface NotesFieldDEProps {
  value: string | null;
  onChange?: (value: string) => void;
  onBlur?: () => void;
  onFocus?: () => void;
  disabled?: boolean;
  placeholder?: string;
  minRows?: number;
  maxRows?: number;
  height?: string;
  maxHeight?: string;
  resize?: "none" | "both" | "horizontal" | "vertical";
}

export const NotesFieldDE = ({
  value,
  onChange = () => {},
  onBlur = () => {},
  onFocus = () => {},
  disabled = false,
  placeholder = "Notes",
  minRows = 4,
  maxRows = 4,
  height,
  maxHeight,
  resize,
}: NotesFieldDEProps) => {
  return (
    <Box
      component={TextareaAutosize}
      placeholder={placeholder}
      minRows={minRows}
      maxRows={maxRows}
      value={value ?? ""}
      onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => {
        onChange(e.target.value);
      }}
      onBlur={onBlur}
      onFocus={onFocus}
      disabled={disabled}
      sx={{
        width: "100%",
        ...(height && { height }),
        ...(maxHeight && { maxHeight }),
        ...(resize && { resize }),
        padding: "10px 12px",
        border: (theme: Theme) => `1px solid ${theme.palette.grey[400]}`,
        borderRadius: "4px",
        fontFamily: (theme: Theme) => theme.typography.fontFamily,
        fontSize: (theme: Theme) => theme.typography.fontSize,
        transition: (theme: Theme) =>
          theme.transitions.create(["border-color", "box-shadow"]),
        "&:hover": {
          borderColor: (theme: Theme) => theme.palette.text.primary,
        },
        "&:focus": {
          borderColor: (theme: Theme) => theme.palette.primary.main,
          boxShadow: (theme: Theme) =>
            `0 0 0 2px ${theme.palette.primary.light}`,
          outline: "none",
        },
        "&::placeholder": {
          color: (theme: Theme) => theme.palette.text.secondary,
          opacity: 1,
          fontSize: "0.9rem",
        },
      }}
    />
  );
};
